module.exports = __webpack_public_path__ + "res/img_usage_type_influencer.605d17979b987182cc231fdde2f1915d.png";